jQuery(document).ready(function ($) {
  const $mobileMenuToggle = $(".mobile-menu-toggle");
  const $mobileNavigation = $(".mobile-navigation");

  // Toggle mobile menu
  $mobileMenuToggle.on("click", function () {
    $mobileNavigation.toggleClass("active");
    $mobileMenuToggle.toggleClass("active");
  });

  // Clique sur la flèche pour afficher ou masquer le sous-menu
  $(".mobile-nav-menu-principal .menu-item-has-children > a").on(
    "click",
    function (e) {
      e.preventDefault();
      e.stopPropagation();

      // Trouve le parent li de l'élément cliqué
      var parentLi = $(this).closest("li");

      // Affiche ou masque le sous-menu du parent li
      parentLi.children(".sub-menu").toggleClass("active");

      // Ajoute ou supprime la classe 'open' pour indiquer l'état du sous-menu
      parentLi.toggleClass("open");
    }
  );
});

//Etat de ma langue

// document.addEventListener("DOMContentLoaded", function () {
//   const lang = document.cookie
//     .split("; ")
//     .find((row) => row.startsWith("googtrans="));

//   if (lang) {
//     const currentLang = lang.split("=")[1].split("/")[2]; // ex: "/fr/en" → "en"
//     console.log("Langue actuelle :", currentLang);

//     const banners = document.getElementsByClassName("c-banner");
//     if (banners.length > 0) {
//       banners[0].classList.remove("d-none");
//     }
//   }
// });
